import { StatusBar } from "expo-status-bar";
import { StyleSheet, Text, View, Image } from "react-native";

import { withDecay } from "react-native-reanimated";
import { useEffect, useState } from "react";

import AppLoading from "expo-app-loading";

import * as Font from "expo-font";
import * as Progress from "react-native-progress";

export const LoadingScreen = () => {
    const [progress, setProgress] = useState(0.0);

  useEffect(() => {
    // Calculate the increment based on the time duration (30 seconds) and interval (100ms)
    const duration = 10000; // 10
    const intervalTime = 100; // Update every 100ms
    const increment = 1.0 / (duration / intervalTime);

    const interval = setInterval(() => {
      setProgress((prevProgress) => {
        if (prevProgress < 1.0) {
          return Math.min(prevProgress + increment, 1.0); // Ensure it doesn't exceed 1.0
        } else {
          clearInterval(interval); // Clear interval if it reaches 1.0
          return prevProgress; // Return the final value
        }
      });
    }, intervalTime);

    return () => clearInterval(interval); // Cleanup on unmount
  }, []);

//   useEffect(() => {
//     console.log('progress', progress);
//   }, [progress])
  return (
    <View style={styles.container}>
      <Progress.Circle
        progress={progress} // Value between 0 and 1
        size={100} // Size of the circle
        showsText={true} // Show percentage inside the circle
        textStyle={styles.text} // Style for the text (optional)
        thickness={8} // Thickness of the circle
        color={"#3498db"} // Color of the circle
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "blue", // Background color behind the red view
  },
  text: {},
});
